"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ReportErrorStateViewComponent = /** @class */ (function () {
    function ReportErrorStateViewComponent() {
        this.REPORT_ERROR_STATE_MESSAGE = 'reporting.controls.control.invalid-state.error';
        this.REPORT_ERROR_STATE_SOLUTION_MESSAGE = 'reporting.controls.control.invalid-state.error-solution';
    }
    ReportErrorStateViewComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-tabular-report-error-state-view',
            template: require('./sis-tabular-report-error-state-view.component.html'),
            styles: [require('./sis-tabular-report-error-state-view.component.css')]
        })
    ], ReportErrorStateViewComponent);
    return ReportErrorStateViewComponent;
}());
exports.ReportErrorStateViewComponent = ReportErrorStateViewComponent;
//# sourceMappingURL=sis-tabular-report-error-state-view.component.js.map